import useTranslate from "hooks/useTranslate";
import Clock from "assets/icons/glory/alarm.svg?react";
import LoyaltyBtnNext from "assets/icons/loyalty/arrow_next.svg?react";
import classNames from "classnames";
import React from "react";
import "./styles.sass";

export type LoyaltyRollbackButtonProps = {
  id?: string;
  onClick: () => void;
  className?: string;
};

const LoyaltyRollbackButton = (props: LoyaltyRollbackButtonProps) => {
  const { className, ...otherProps } = props;
  const t = useTranslate();
  return (
    <button
      type="button"
      className={classNames("LoyaltyRollbackButton", className)}
      {...otherProps}
    >
      <Clock className="LoyaltyRollbackButton__icon" />
      <div className="LoyaltyRollbackButton__content">
        <div className="LoyaltyRollbackButton__title">
          {t("loyalty.rollback")}
        </div>
        <div className="LoayltyRollbackButton__subtitle">
          {t("loyalty.rollback.btn.text")}
        </div>
      </div>
      <div className="LoayltyRollbackButton__arrow">
        <LoyaltyBtnNext />
      </div>
    </button>
  );
};

export default LoyaltyRollbackButton;
